module.exports = __webpack_public_path__ + "static/media/p5min-min.b9aa6a05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/p5min-min.jpg
// module id = 283
// module chunks = 0